import { Box, useMediaQuery } from "@mui/material";
import { useEffect, useState, useCallback, lazy, Suspense } from "react";
import { motion } from "framer-motion";
import { useTheme } from "@mui/material/styles";
import ChatBot from "../chat/ChatBoat";
import Navbar from "../components/navbar";
import HeroSection from "../components/HeroSection";
import SearchBar from "../components/SearchBar";
import PopupDialog from "../components/AlertPopUp";
import Footer from "../components/Footer";
import SecondaryFooter from "../components/secondaryFooter";
import { CircularProgress } from "@mui/material";
import GharnMakaanFeatures from "../components/GharnMakaanFeatures";

/* ======================
   Lazy Loaded Sections
====================== */

const ExploreCities = lazy(() => import("../components/exploreCities"));
const RecentProperties = lazy(() => import("../components/RecentProperties"));
const PostNow = lazy(() => import("../components/PostNow"));
const LocationBasedProperties = lazy(() => import("../components/locationBasedProperties"));
const SearchCommercialProperty = lazy(() => import("../components/SearchCommercialProperty"));
const SearchForRent = lazy(() => import("../components/SerachForRent"));
const OurNumbers = lazy(() => import("../components/ourNumbers"));
const WhyChooseUs = lazy(() => import("../components/whyChooseUs"));

export default function HomePage() {
  const theme = useTheme();

  const [open, setOpen] = useState(false);
  const [purpose, setPurpose] = useState("Buy");

  const handlePurposeChange = useCallback((newPurpose) => {
    setPurpose(newPurpose);
  }, []);

  useEffect(() => {
    const hasSeenPopup = localStorage.getItem("popupSeen");
    if (!hasSeenPopup) {
      setOpen(true);
      localStorage.setItem("popupSeen", "true");
    }
  }, []);

  return (
    <>
      {/* ================= HEADER ================= */}
      <Navbar />

      <PopupDialog
        open={open}
        onClose={() => setOpen(false)}
        onConfirm={() => setOpen(false)}
        showCancel={false}
      />

      {/* ================= HERO ================= */}
      <Box
        component={motion.div}
        initial={{ opacity: 0, y: -40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          width: "100%",
          overflowX: "hidden",
        }}
      >
        <Box
          sx={{
            width: "100%",
            position: "relative",
            display: "flex",
            justifyContent: "center",

          }}
        >
          <HeroSection />

          <Box
            sx={{
              position: "absolute",
              width: { xs: "85%", sm: "70%", md: "60%", lg: "55%" },
              top: "90%",
              zIndex: 2,
              borderRadius: 2,
            }}
          >
            <SearchBar onPurposeChange={handlePurposeChange} />
          </Box>
        </Box>

        {/* ================= BELOW THE FOLD ================= */}
        <Suspense
          fallback={
            <Box sx={{ py: 6 }}>
              <CircularProgress />
            </Box>
          }
        >
          <ExploreCities purpose={purpose} />
          <RecentProperties />
          <PostNow />
          <LocationBasedProperties purpose={purpose} />
          <SearchCommercialProperty />
          <SearchForRent />
          <OurNumbers />
          <WhyChooseUs />
<GharnMakaanFeatures/>
        </Suspense>
      </Box>
      {/* ================= FOOTER ================= */}
      <SecondaryFooter />
      <Footer />
      <ChatBot/>
    </>
  );
}
